import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';

interface IOwnProps {
    id: string,
    count: number,
    message: string,
}


const ChipWithTooltip = (props: IOwnProps) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <Tooltip
            sx={{ fontSize: '14px' }}
            title={props.message}
            open={isHovered} arrow>
            <Chip
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                key={props.id}
                label={`+ ${props.count} more`}
            />
        </Tooltip>
    );
}

export default ChipWithTooltip;
